<template>
  <v-app>
    <div
      v-if="loading === true"
      class="text-center"
    >
      <v-progress-circular
        :size="70"
        :width="10"
        color="blue"
        indeterminate
      />
      <br>
      お客様の情報を確認中です。<br>
      処理が完了するまでお待ちください。
    </div>
    <div
      v-if="loading === false"
      class="ma-5"
    >
      <b>よくある質問</b><br>
      <p v-html="qa" />
    </div>
  </v-app>
</template>

<script>
import firebase from "firebase";
export default {
  name: "Rule",
  data() {
    return {
      loading: true,
      qa: "",
    };
  },

  created: function () {
    this.getWelcome();
  },
  methods: {
    async getWelcome() {
      var welcome = await firebase.functions().httpsCallable("welcome");
      welcome().then((result) => {
        this.qa = result.data.welcome.qa;
        console.log(this.qa);
        this.loading = false;
      });
    },
  },
};
</script>
